import { useSelector } from "react-redux";
import selectors from "selectors";
import EditInfo from "./edit-info";
import EditPhysician from "./edit-physician";
import EditInsurance from "./edit-insurance";

const EditProfileScreen = ({ formProps, selectedTab }) => {
  const profile = useSelector(selectors.getPatientProfile);

  return (
    <>
      {selectedTab === 0 && (
        <div role="tabpanel" id="profile-tabpanel-0" aria-labelledby="profile-tab-0">
          <EditInfo {...formProps} />
        </div>
      )}
      {selectedTab === 1 && (
        <div
          role="tabpanel"
          id="profile-tabpanel-1"
          aria-labelledby="profile-tab-1"
          style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}
        >
          <EditInsurance
            {...formProps}
            insurance_types={profile.insurance_types}
          />
          <EditPhysician {...formProps} />
        </div>
      )}
    </>
  );
};

export default EditProfileScreen;
